import React, { useState } from 'react'
import style from '../style'
import propTypes from './prop'
import ItemLayout from '../../renderer/item-layout'
import isEmpty from '../../../../utils/is-empty'
import { withStyles, Grid } from '@material-ui/core'
import ContainerMediaGalery from '../../../image-gallery'
import { PatchData } from '../../../../model/patch'
import URL from '../../../../api/url'

import { Icon } from '@iconify/react'
import { CoreIconButton } from 'src/components/core'
import {
  messageBoxHideAction,
  messageBoxShowAction,
} from 'src/reducers/message-box/action'
import MessageBoxContent, { MessageBoxType } from 'src/model/message-box'
const FormItemMediaImage = props => {
  const { classes, dispatch, value, updateEntityKeyValue } = props
  const [stateValue, setStateValue] = useState(value)

  /**
   *
   */
  const handleAddImage = () => {
    /**
     *
     * @param {} items
     */
    const onOk = items => {
      const item = items[0]

      setStateValue(URL.STORAGE + item.url)

      updateEntityKeyValue(
        URL.STORAGE + item.url,
        props,
        PatchData.OPERATION_REPLACE,
      )

      dispatch(messageBoxHideAction())
    }

    dispatch(
      messageBoxShowAction(
        MessageBoxContent({
          type: MessageBoxType.WARNING,
          buttons: [],
          title: `
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 8px;
              "
            >
           
            <Icon
              icon="ic:round-add-a-photo"
              color="#00AB55"
              width="24"
              height="24"
            />
            <Typography
              style="
                margin-left: 8;
                color: #002E47;
                fontWeight: 600;
                fontSize: 16;
              "
            >
              Media Gallery
            </Typography>
          </div>`,
          draggable: true,
          component: <ContainerMediaGalery onOk={onOk} />,
          maxHeight: '70vh',
        }),
      ),
    )
  }

  /**
   *
   */
  const handleRemove = () => {
    setStateValue(null)

    updateEntityKeyValue(null, props, PatchData.OPERATION_REPLACE)
  }

  let element = ''

  if (stateValue) {
    element = (
      <Grid>
        <img
          src={/* URL.STORAGE + */ stateValue}
          className={classes.mediaImage}
          alt=""
        />
        <CoreIconButton
          onClick={handleRemove}
          variant="text"
          size="small"
          color="dark"
        >
          <Icon icon="ic:round-close" />{' '}
        </CoreIconButton>
      </Grid>
    )
  } else {
    element = (
      <CoreIconButton
        onClick={handleAddImage}
        variant="text"
        size="small"
        color="dark"
      >
        <Icon icon="mdi:image-outline" />
      </CoreIconButton>
    )
  }
  return (
    <ItemLayout
      hasContent={!isEmpty(stateValue)}
      formItem={props}
      element={element}
    />
  )
}

FormItemMediaImage.propTypes = propTypes

export default withStyles(style)(FormItemMediaImage)
